import React from 'react';
import { useLocation } from 'react-router-dom';

import { ScanDetailsProps } from './ScanDetails.props';

import ScanDetailsView from './ScanDetails.view';

const ScanDetailsContainer = (props: ScanDetailsProps) => {
  const location = useLocation();
  const scan = location.state;

  return <ScanDetailsView scan={scan} />;
};

export default ScanDetailsContainer;
